export default __webpack_public_path__ + "static/media/manaup.f23e2857.svg";